import React from 'react';
import { Box } from '@components/Box';
import { ourStoryPageData } from '@data-ts/pages/our-story';
import { Flex } from '@components/Flex';
import { WrapperBox, StyledFlex, PhotosFlex, StyledTextPairing, StyledImageContainer, StyledImageWrapper } from './PhotoCollection.styles';
import ReactHtmlParser from 'react-html-parser';

const imagesInfo = [
  { width: 310, height: 400, mobileWidth: 110, mobileHeight: 160 },
  { width: 310, height: 300, mobileWidth: 110, mobileHeight: 160 },
  { width: 368, height: 348, mobileWidth: 110, mobileHeight: 160 },
  { width: 563, height: 500, mobileWidth: 220, mobileHeight: 195 },
  { width: 563, height: 400, mobileWidth: 220, mobileHeight: 149 },
  { width: 352, height: 295, mobileWidth: 130, mobileHeight: 160 },
  { width: 351, height: 360, mobileWidth: 130, mobileHeight: 160 },
  { width: 258, height: 300, mobileWidth: 125, mobileHeight: 160 },
  { width: 99, height: 300, mobileWidth: 32, mobileHeight: 160 },
  { width: 350, height: 560, mobileWidth: 130, mobileHeight: 160 },
  { width: 350, height: 272, mobileWidth: 130, mobileHeight: 160 },
];

export const PhotoCollection = () => {
  const { photoCollectionData } = ourStoryPageData;
  const { photos } = photoCollectionData;
  return (
    <WrapperBox paddingTop={[8, 10]} paddingBottom={[5, 10]}>
      <StyledFlex justifyContent="center" paddingX={[6, 0]} marginBottom={[9, 10]}>
        <StyledTextPairing
          eyebrow={photoCollectionData.eyebrow}
          eyebrowVariant="sectionEyeBrow20"
          eyebrowColor="humana5"
          eyebrowTagName="h3"
          title={ReactHtmlParser(photoCollectionData.title)}
          titleVariant="hed40"
          titleColor="neutra6"
          titleTagName="h3"
        />
        <StyledTextPairing
          eyebrow={photoCollectionData.body}
          eyebrowVariant="sectionEyeBrow24"
          eyebrowColor="neutra5"
          title=""
          titleVariant="hed40"
        />
      </StyledFlex>
      <PhotosFlex>
        <Box marginLeft={[0, 0]}>
          {[0, 1, 2].map(item => (
            <StyledImageWrapper
              key={item}
              width={imagesInfo[item].width}
              reswidth={imagesInfo[item].mobileWidth}
              height={imagesInfo[item].height}
              resheight={imagesInfo[item].mobileHeight}
              margin={[2, 4]}
              marginLeft={item === 2 ? [-10, -13, -10] : [-10, -12, -2]}
              padding={[0, 4]}
            >
              <StyledImageContainer optimization="mild" src={photos[item]} alt={photoCollectionData.altText} width="97%" height="95%" />
            </StyledImageWrapper>
          ))}
        </Box>
        <Box paddingTop={[9, 12]}>
          {[3, 4].map(item => (
            <StyledImageWrapper
              key={item}
              width={imagesInfo[item].width}
              reswidth={imagesInfo[item].mobileWidth}
              height={imagesInfo[item].height}
              resheight={imagesInfo[item].mobileHeight}
              margin={[2, 4]}
              padding={[2, 0]}
            >
              <StyledImageContainer
                objectfit={'contain'}
                src={photos[item]}
                alt={photoCollectionData.altText}
                width="97%"
                height="95%"
                optimization="mild"
              />
            </StyledImageWrapper>
          ))}
        </Box>
        <Box paddingTop={[5, 10]}>
          {[5, 6, 7].map(item => {
            if (item !== 7) {
              return (
                <StyledImageWrapper
                  key={item}
                  width={imagesInfo[item].width}
                  reswidth={imagesInfo[item].mobileWidth}
                  height={imagesInfo[item].height}
                  resheight={imagesInfo[item].mobileHeight}
                  margin={[2, 4]}
                  padding={[2, 4]}
                >
                  <StyledImageContainer
                    objectfit="contain"
                    src={photos[item]}
                    alt={photoCollectionData.altText}
                    optimization="mild"
                    width="97%"
                    height="95%"
                  />
                </StyledImageWrapper>
              );
            }
            return (
              <Flex key={'row70'}>
                <StyledImageWrapper
                  key={`row71`}
                  width={imagesInfo[item].width}
                  reswidth={imagesInfo[item].mobileWidth}
                  height={imagesInfo[item].height}
                  resheight={imagesInfo[item].mobileHeight}
                  margin={[2, 4]}
                  padding={[2, 4]}
                >
                  <StyledImageContainer
                    objectfit="contain"
                    src={photos[item]}
                    alt={photoCollectionData.altText}
                    optimization="mild"
                    width="97%"
                    height="95%"
                  />
                </StyledImageWrapper>
                <StyledImageWrapper
                  key={`row72`}
                  width={imagesInfo[item + 1].width}
                  reswidth={imagesInfo[item + 1].mobileWidth}
                  height={imagesInfo[item + 1].height}
                  resheight={imagesInfo[item + 1].mobileHeight}
                  margin={[2, 4]}
                  padding={[2, 0]}
                >
                  <StyledImageContainer
                    objectfit="contain"
                    src={photos[item + 1]}
                    alt={photoCollectionData.altText}
                    optimization="mild"
                    width="97%"
                    height="90%"
                  />
                </StyledImageWrapper>
              </Flex>
            );
          })}
        </Box>
        <Box>
          {[9, 10].map(item => (
            <StyledImageWrapper
              key={item}
              width={imagesInfo[item].width}
              reswidth={imagesInfo[item].mobileWidth}
              height={imagesInfo[item].height}
              resheight={imagesInfo[item].mobileHeight}
              margin={[2, 4]}
              padding={[2, 4]}
            >
              <StyledImageContainer
                objectfit={'contain'}
                src={photos[item]}
                alt={photoCollectionData.altText}
                optimization="mild"
                width="97%"
                height="95%"
              />
            </StyledImageWrapper>
          ))}
        </Box>
      </PhotosFlex>
    </WrapperBox>
  );
};
